"use client"

import { MessageSquare } from "lucide-react"
import { useTranslation } from "@/lib/i18n"

// ─── Compact welcome for PiP ─────────────────────────────────────────────────
// Moved out of chat-companion.tsx (#933) so it can be tested on its own. Its
// line names the workspace: "about your recipients" read on every page.
export function CompactWelcome({ onSuggestion }: { onSuggestion: (text: string) => void }) {
  const { t } = useTranslation()
  const quickSuggestions = [
    "Show me all active recipients",
    "What's our data quality score?",
    "List all groups",
  ]

  return (
    <div className="flex flex-col items-center justify-center flex-1 px-3 py-6">
      <MessageSquare className="h-8 w-8 text-primary/40 mb-3" />
      <p className="text-xs text-muted-foreground mb-4 text-center">
        {t('aiChat.askAnything')}
      </p>
      <div className="flex flex-col gap-1.5 w-full">
        {quickSuggestions.map((s) => (
          <button
            key={s}
            onClick={() => onSuggestion(s)}
            className="text-start text-xs px-3 py-2 rounded-lg border border-border hover:bg-accent/50 transition-colors truncate"
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  )
}
